module.exports = __webpack_public_path__ + "static/main-banner_photos-left_32_11zon-d37dc9754483c47ffbd30b17d2001e4d.webp";